var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"imgWrapper"}},[(_vm.src === '')?_c('img',{staticClass:"picImg",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":require("../../assets/bglogo.png")}}):_c('img',{ref:"img",staticClass:"picImg",attrs:{"src":_vm.loadingSrc,"origin-url":_vm.originUrl,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }